import { Box, Button, Typography } from "@mui/material";
import JoditEditor from "jodit-react";
import React, { useEffect, useRef, useState } from "react";
import UploadBid from "./UploadBid";
import "./postbid-modern.css";

function PostBidDescription({ bidData, assistantDraft }) {
  const ref = useRef(null);
  const [next, setNext] = useState(false);
  const [data, setData] = useState(assistantDraft?.description || "");
  const [validDesc, setValidDesc] = useState(false);
  const editorConfig = {
    readonly: false,
    toolbar: true,
    spellcheck: true,
    language: "en",
    toolbarButtonSize: "small",
    toolbarAdaptive: false,
    buttons: ["bold", "italic", "ul", "ol", "link", "undo", "redo"],
    placeholder: "התחל לכתוב....",
    showCharsCounter: false,
    showWordsCounter: false,
    showXPathInStatusbar: false,
    statusbar: false,
    hidePoweredByJodit: true,
    askBeforePasteHTML: true,
    askBeforePasteFromWord: true,
    uploader: { insertImageAsBase64URI: true },
  };

  useEffect(() => {
    if (assistantDraft?.description) {
      sessionStorage.removeItem("biditAssistantDraft");
      sessionStorage.removeItem("biditAssistantReturnTo");
    }
  }, [assistantDraft]);

  const handleSubmit = () => {
    setValidDesc(false);
    if (data.replace(/<[^>]*>/g, "").trim().length < 20) {
      setValidDesc(true);
      return;
    }
    bidData.description = data;
    bidData.notes = "";
    setNext(true);
  };

  return (
    <Box className="bidit-postbid-step" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>
      {!next && (
        <Box className="bidit-form-card">
          <Box className="bidit-form-intro">
            <Box className="bidit-form-intro-badge"><span className="bidit-form-intro-spark">✦</span>שלב אחרון</Box>
            <Typography variant="h6" className="bidit-form-title" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>ספרו קצת יותר על העבודה</Typography>
            <Typography className="bidit-form-subtitle" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>פירוט ברור יעזור לבעלי המקצוע לתת הצעה מדויקת יותר</Typography>
          </Box>
          <Box sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>
            <JoditEditor value={data} ref={ref} config={editorConfig} onBlur={(newContent) => setData(newContent)} />
          </Box>
          {validDesc && <Box className="bidit-inline-error">התיאור צריך להיות לפחות 20 תווים</Box>}
          <Button className="bidit-primary-button" sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, marginTop: "24px", width: "100%" }} variant="contained" onClick={handleSubmit}>
            פרסום המכרז
          </Button>
        </Box>
      )}
      {next && <UploadBid bidData={bidData} />}
    </Box>
  );
}
export default PostBidDescription;
